import { Typography } from "@mui/material";
import type { MultiSelectObjectFilter, SelectOption } from "../../api/types/objectTypes";
import { getMultiSelectFilterValuesText, multiSelectFilterOperatorCaptions } from "./objectFilterHelpers";

interface Props {
  fieldName: string;
  filter: MultiSelectObjectFilter;
  options?: SelectOption[];
  startLabel: string;
}

const ObjectMultiSelectFilterDescription = ({ fieldName, filter, options, startLabel }: Props) => {
  return (
    <Typography>
      {startLabel} <strong>{fieldName}</strong> {multiSelectFilterOperatorCaptions[filter.operator] ?? filter.operator}{" "}
      <strong>{getMultiSelectFilterValuesText(filter, options)}</strong>
    </Typography>
  );
};

export default ObjectMultiSelectFilterDescription;
